<template>
    <div :class="[isBridgePageEnabled ? 'check-for-dups-setup-page container-width' : 'check-for-dups-setup-page']">
        <h2 data-qa="title">
            {{ title }}
        </h2>

        <div v-if="!isBridgePageEnabled" class="actions search-bar">
            <ds-input-field
                v-model="searchInput"
                :label="$options.SEARCH_LABEL"
                data-qa="search-label"
            >
                <ds-icon slot="leading" name="search" />
            </ds-input-field>
        </div>

        <check-for-dups-block
            v-for="(block, index) in checkForDupsBlocks"
            :key="index"
            data-qa="check-for-dups-block"
            :block-configuration="block"
            :is-bridge-page-enabled="isBridgePageEnabled"
        />

        <div v-if="checkForDupsBlocks.length === 0" class="no-result">
            <h3>{{ $options.NO_RESULTS }}</h3>
        </div>
    </div>
</template>
<script>
import CHECK_FOR_DUPS_ENTRIES from './checkForDupsPageEntries.json';
import CHECK_FOR_DUPS_SPA_ENTRIES from './checkForDupsPageSpaEntries.json';
import CheckForDupsBlock from './CheckForDupsBlock';
import axios from 'axios';

export const TITLE = 'Clean Up Your Data';
export const WEB_TITLE = 'Data cleanup';
export const SEARCH_LABEL = 'Search Clean Up Your Data';
export const NO_RESULTS = 'No results';

export default {
    checkForDupsEntries: CHECK_FOR_DUPS_ENTRIES,
    checkForDupsSpaEntries: CHECK_FOR_DUPS_SPA_ENTRIES,
    TITLE,
    WEB_TITLE,
    SEARCH_LABEL,
    NO_RESULTS,

    components: {
        CheckForDupsBlock,
    },

    data() {
        return {
            searchInput: '',
            isBridgePageEnabled: false,
        };
    },

    created() {
        this.getFeatureFlagValue();
    },

    computed: {
        title() {
            return this.isBridgePageEnabled ? WEB_TITLE : TITLE;
        },

        checkForDupsBlocks() {
            const search = this.searchInput?.trim()?.toLowerCase();

            if (this.isBridgePageEnabled) {
                return this.$options.checkForDupsSpaEntries;
            }

            return this.filteredBlocks(search);
        },
    },

    methods: {
        async getFeatureFlagValue() {
            const response = await axios.get('/app/contact/isBridgePageEnabled');

            this.isBridgePageEnabled = response.data;
        },

        filteredBlocks(search) {
            if (search !== '') {
                let filteredBlocks = this.$options.checkForDupsEntries.map((block) => {
                    const { columns } = block;

                    let filteredColumns = columns.map((column) => {
                        const { cards } = column;
                        let filteredCards = cards.map((card) => {
                            const filteredEntries = card.entries.filter(({ title, description }) => {
                                return title.toLowerCase().includes(search)
                      || description.toLowerCase().includes(search);
                            });

                            if (filteredEntries.length > 0) {
                                return {
                                    id: card.id,
                                    entries: filteredEntries,
                                };
                            }

                            return false;
                        });

                        filteredCards = filteredCards.filter((card) => {
                            return card;
                        });

                        if (filteredCards.length > 0) {
                            return {
                                id: column.id,
                                cards: filteredCards,
                            };
                        }

                        return false;
                    });

                    filteredColumns = filteredColumns.filter((column) => {
                        return column;
                    });

                    if (filteredColumns.length > 0) {
                        return {
                            title: block.title,
                            columns: filteredColumns,
                        };
                    }

                    return false;
                });

                filteredBlocks = filteredBlocks.filter((block) => {
                    return block;
                });

                return filteredBlocks;
            }

            return this.$options.checkForDupsEntries;
        },
    },
};
</script>
<style lang="scss" scoped>

    .check-for-dups-setup-page {
        min-height: 100%;
        margin-top: $spacing-400;
    }


    .check-for-dups-setup-page.container-width {
        width: 55rem;
        margin: 7rem 7rem;
        h2 {
            margin-bottom: $spacing-200;
        }
    }


    .actions {
        display: flex;
        flex-wrap: wrap;
        width: 15rem;
        margin: 20px 0 24px 0;
        justify-items: left;
    }
</style>
